import styled from 'styled-components';

import {
  PanelHeaderSection,
  PanelHeaderTitle,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/PanelHeaderTitle';
import { ScreenSectionsEditor } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ScreenSectionsPanel/ScreenSectionsEditor';
import { SelectedStep } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenEditor/InquiryTemplateScreenEditor';
import {
  InquiryTemplateVersionStep,
  InquiryTemplateVersionStepIntegration,
  InquiryTemplateVersionStepUi,
} from 'dashboard/models/inquiry-template-version';
import { StepPreview } from 'lib/interfaces/StepsConfig';
import { UiComponentConfig } from 'lib/interfaces/ui-components';
import { ThemeAttributes } from 'verify/models/theme';

const InquiryTemplateEditorScreenSectionsPanel = styled.div`
  overflow: hidden;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
`;

export type ScreenSectionsPanelProps = {
  selectedStep: SelectedStep;
  currentStep: InquiryTemplateVersionStepUi | InquiryTemplateVersionStepIntegration;
  stepPreview: StepPreview;
  availableBackSteps: InquiryTemplateVersionStep[];
  basePath: string;
  theme?: ThemeAttributes;
  editable: boolean;
  handleClosePanel: () => void;
  handleComponentPaste?: () => void;
  updateSteps: ({
    updatedStep,
    component,
  }: {
    updatedStep: InquiryTemplateVersionStep;
    component?: UiComponentConfig;
  }) => void;
};

export const ScreenSectionsPanel = ({
  selectedStep,
  currentStep,
  stepPreview,
  availableBackSteps,
  basePath,
  theme,
  editable,
  handleComponentPaste,
  handleClosePanel,
  updateSteps,
}: ScreenSectionsPanelProps) => (
  <InquiryTemplateEditorScreenSectionsPanel>
    <PanelHeaderSection>
      <PanelHeaderTitle
        title={selectedStep.displayName}
        subtitle='Screen'
        basePath={basePath}
        editable={editable}
      />
    </PanelHeaderSection>
    <ScreenSectionsEditor
      step={currentStep}
      stepPreview={stepPreview}
      availableBackSteps={availableBackSteps}
      handleComponentPaste={handleComponentPaste}
      handleClosePanel={handleClosePanel}
      basePath={basePath}
      theme={theme}
      updateSteps={updateSteps}
      editable={editable}
    />
  </InquiryTemplateEditorScreenSectionsPanel>
);
